// extracted by mini-css-extract-plugin
var _1 = "AIButtonContainedGrey-moduleaiButtonContainedGrey__DeVYQ";
var _2 = "AIButtonContainedGrey-modulelabel__cW_ty";
export { _1 as "aiButtonContainedGrey", _2 as "label" }
